<template>
  <div class="tolerance-page">
    <div class="container">
      <h1 class="page-title">3D Printing Capabilities</h1>

      <div class="tolerance-table-wrapper">
        <table class="tolerance-table">
          <thead>
            <tr>
              <th></th>
              <th>SLA</th>
              <th>MJF</th>
              <th>SLS</th>
              <th>SLM</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Min. Wall Thickness</td>
              <td>0.6mm for unsupported walls, 0.4mm for supported walls on both sides</td>
              <td>At least 1mm thick; avoid overly thick walls</td>
              <td>From 0.7mm (PA 12) to 2.0mm (carbon-filled polyamide)</td>
              <td>0.8 mm</td>
            </tr>
             <tr>
              <td>Layer Height</td>
              <td>25 µm to 100µm</td>
              <td>Around 80µm</td>
              <td>100–120 microns</td>
              <td>30 – 50μm</td>
            </tr>
             <tr>
              <td>Max. Build Size</td>
              <td>1400x700x500mm</td>
              <td>264x343x348mm</td>
              <td>380x280x380mm</td>
              <td>320x320x400mm</td>
            </tr>
             <tr>
              <td>Dimension Tolerance</td>
              <td>±0.2mm (For >100mm, apply 0.15%)</td>
              <td>±0.2mm (For >100mm, apply 0.25%)</td>
              <td>± 0.3mm (For >100mm, apply 0.35%)</td>
              <td>±0.2mm (For >100mm, apply 0.25%)</td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <div class="button-wrapper">
        <button class="getQuote-btn" @click="$router.push('/quote')">Get Instant Quote</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'printing_Capabilities'
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
}

.tolerance-page {
  /* ✨ 利用 clamp 实现动态内边距：最小 30px，按 5vw 缩放，最大 60px */
  padding: clamp(30px, 5vw, 60px) 20px;
  background-color: #ffffff;
}

.container {
  max-width: 1000px;
  margin: 0 auto;
  text-align: center;
  display: flex;
  flex-direction: column;
}

/* 标题样式 */
.page-title {
  /* ✨ 标题动态字号：手机端最小 26px，大屏最大 36px */
  font-size: clamp(26px, 4vw, 36px);
  color: #333333;
  margin: 0 0 clamp(20px, 4vw, 30px);
  font-weight: 600;
}

.tolerance-table-wrapper {
  width: 100%;
  margin-bottom: 30px;
  overflow-x: auto; /* ✨ 允许横向滑动 */
  -webkit-overflow-scrolling: touch; /* ✨ 让 iOS 设备上滑动更顺滑 */
}

.tolerance-table {
  width: 100%;
  min-width: 800px; /* ✨ 核心：因为有5列，所以最小宽度提高到 800px，防止文字被严重挤压 */
  border-collapse: collapse;
  background-color: #ffffff;
  table-layout: fixed;
}

.tolerance-table thead tr {
  background-color: #f0f4f5;
}

.tolerance-table th,
.tolerance-table td {
  padding: 20px 15px;
  text-align: center;
  border: 1px solid #e5e7eb;
  color: #333333;
  font-size: 16px;
  line-height: 1.5;
}

.tolerance-table th {
  font-weight: 700;
}

/* 第一列加粗并分配宽度 */
.tolerance-table th:first-child,
.tolerance-table td:first-child {
  font-weight: 600;
  width: 20%; /* ✨ 第一列占20%，剩下的4列自然平分剩下的80% */
}

/* 按钮容器 */
.button-wrapper {
  display: flex;
  justify-content: center;
}

.getQuote-btn {
  background-color: #16bc9c;
  color: #ffffff;
  border: none;
  padding: 14px 30px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

/* ✨ 修复了原来写错的类名 (.download-btn) */
.getQuote-btn:hover {
  background-color: #13a88b;
}

/* 响应式适配 */
@media (max-width: 768px) {
  .tolerance-table th,
  .tolerance-table td {
    padding: 15px 10px;
    font-size: 14px;
  }
}
</style>